export enum moduleCampaignSmsNames {
  SET_CAMPAIGN_SMS_TIP = "SET_CAMPAIGN_SMS_TIP",
  SET_CAMPAIGN_SMS_TIP_SEND_TEST = "SET_CAMPAIGN_SMS_TIP_SEND_TEST",
}
